module.exports = __webpack_public_path__ + "static/img/baloon.5ef9b96.png";